/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingWallet } from './BillingWallet';
import {
    BillingWalletFromJSON,
    BillingWalletFromJSONTyped,
    BillingWalletToJSON,
    BillingWalletToJSONTyped,
} from './BillingWallet';

/**
 * 
 * @export
 * @interface ListBillingWalletsResponse
 */
export interface ListBillingWalletsResponse {
    /**
     * 
     * @type {Array<BillingWallet>}
     * @memberof ListBillingWalletsResponse
     */
    data: Array<BillingWallet>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListBillingWalletsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListBillingWalletsResponse interface.
 */
export function instanceOfListBillingWalletsResponse(value: object): value is ListBillingWalletsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListBillingWalletsResponseFromJSON(json: any): ListBillingWalletsResponse {
    return ListBillingWalletsResponseFromJSONTyped(json, false);
}

export function ListBillingWalletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillingWalletsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingWalletFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListBillingWalletsResponseToJSON(json: any): ListBillingWalletsResponse {
      return ListBillingWalletsResponseToJSONTyped(json, false);
  }

  export function ListBillingWalletsResponseToJSONTyped(value?: ListBillingWalletsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingWalletToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

